export const FileTypesMap = {
  CORE: 'core',
  CHEWY_CATALOG: 'CHEWY_CATALOG',
  MATCH: 'match',
  INTERNAL: 'internal',
  PREVIOUS_RUN: 'previousRun',
  PREVIOUS_RUN_ADVANCED: 'previousRunAdvanced',
  BATCH: 'inputBatch',
  INPUT: 'input'
};

export const FileMimeTypesMap = {
  CSV: 'text/csv',
  HTML: 'text/html',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

export const FileUploadType = {
  UPLOADS: 'uploads',
  SALES_HISTORIES: 'sales_histories',
  PREVIOUS_RUNS: 'previous_runs',
  INVENTORY_FILES: 'inventory_files'
};

export const SupportedSessionFileName = {
  COMPANY: 'Company.csv',
  STATS: '__stats.html',
  HEALTH_CHECK: '__healthCheck.csv',
  UNCLASSIFIED_INVOICE_LINES: '__unclassifiedInvoiceLines.csv',
  UNMATCHED_INVOICE_LINES: '__unmatchedInvoiceLines.csv'
};

export const SupportedSessionFiles = [
  {
    name: SupportedSessionFileName.COMPANY,
    mimeType: FileMimeTypesMap.CSV
  },
  { name: SupportedSessionFileName.STATS, mimeType: FileMimeTypesMap.HTML },
  {
    name: SupportedSessionFileName.HEALTH_CHECK,
    mimeType: FileMimeTypesMap.CSV
  },
  {
    name: SupportedSessionFileName.UNCLASSIFIED_INVOICE_LINES,
    mimeType: FileMimeTypesMap.CSV
  },
  {
    name: SupportedSessionFileName.UNMATCHED_INVOICE_LINES,
    mimeType: FileMimeTypesMap.CSV
  }
];
